<template>
  <ul class="c-list-bar">
    <slot />
  </ul>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-list-bar {
  --c-list-bar--font-size: 16px;
  --c-list-bar--line-height: 1.15;
  --c-list-bar--padding: 0;
  --c-list-bar--gap: 8px;
  --c-list-bar--bar-gap: 16px;
  --c-list-bar--bar-width: 16px;
  --c-list-bar--bar-height: 2px;
  --c-list-bar--bar-color: var(--color-secondary);
  --c-list-bar--bar-margin-top: calc(
    var(--c-list-bar--font-size) * var(--c-list-bar--line-height) / 2.3
  );

  font-size: var(--c-list-bar--font-size);
  line-height: var(--c-list-bar--line-height);
  padding: var(--c-list-bar--padding);
  gap: var(--c-list-bar--gap);
  list-style: none;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;

  :deep(> li) {
    margin-bottom: 0;
    display: flex;
    align-items: flex-start;
    gap: var(--c-list-bar--bar-gap);

    &::before {
      content: '';
      display: block;
      width: var(--c-list-bar--bar-width);
      height: var(--c-list-bar--bar-height);
      background-color: var(--c-list-bar--bar-color);
      margin-top: var(--c-list-bar--bar-margin-top);
      flex: 0 0 auto;
      min-width: 0;
    }
  }
}
</style>
